import { PureComponent } from "react";

class GenericTable extends PureComponent {
  render() {
    return "replace me";
  }
}

export default GenericTable;
